import { isSupportedProfileEditCareType } from '@/apps/provider/profile/edit/lib/careTypeUtils';

/**
 * Helper to determine if a care type uses SPA routes for profile editing
 */
export const usesSpaRoutes = (careType: string | undefined): boolean => {
  return careType ? isSupportedProfileEditCareType(careType) : false;
};

/**
 * Helper to generate edit URL - uses new SPA routes for supported care types, fallback for others
 * @param careType - The care type (e.g., 'housekeeping', 'babysitter'), can be undefined
 * @param section - The edit section (e.g., 'bio', 'experience')
 * @param fallbackPath - The legacy edit path to use for non-SPA care types
 */
export const getEditUrl = (careType: string | undefined, section: string, fallbackPath: string): string => {
  return usesSpaRoutes(careType) ? `/provider/profile/${careType}/edit/${section}` : fallbackPath;
};
